// eslint-disable-next-line
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';

import Banner from "../Banner";
import MainContent from "../MainContent";
import Recomended from "../Recommended";
import apiShow from "../../apis/api.show";


function ContentContainer(props){
  const [banner, setBanner] = useState(props.banner?props.banner:{});
    return(
        <>
            <div className="main-wrapper dark astro-sckkx6r4">
  <div id="plan-view" className="plan-view astro-vobjiul6">
    <div className="plan-view__masonry-hero astro-vobjiul6 plan-masonry-hero container container--lg:paddings flex flex--wrap astro-dcpclmto">
      <div
        className="grid-gallery grid-gallery--breakpoint-md astro-phhg3pvv"
        data-testid="grid-gallery"
        data-gallery="grid-gallery"
      >
        <ul className="grid-gallery__list grid-gallery__list--two-items grid-gallery__list--rounded astro-phhg3pvv">
          <li
            className="grid-gallery__item astro-phhg3pvv"
            data-grid-gallery-list-item={0}
            data-testid="grid-gallery-item"
          ></li>
          <li
            className="grid-gallery__item astro-phhg3pvv"
            data-grid-gallery-list-item={1}
            data-testid="grid-gallery-item"
          ></li>
        </ul>
        <div className="grid-gallery-slideshow astro-phhg3pvv"></div>{" "}
        <button
          className="ignt-button ignt-button--small ignt-button--sharp-primary-contrast grid-gallery__gallery-btn astro-phhg3pvv svelte-16cc14r"
          data-open-gallery-item={0}
        >
          <span className="svelte-16cc14r">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              role="img"
              aria-hidden="true"
              focusable="false"
              className="svg-inline--fa fa-grid-2 fa-fw svelte-1ipid5s"
              viewBox="0 0 512 512"
            >
              <path
                fill="currentColor"
                d="M224 80c0-26.5-21.5-48-48-48H80C53.5 32 32 53.5 32 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80zm0 256c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336zM288 80v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48zM480 336c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V336z"
              ></path>
            </svg>{" "}
            Gallery{" "}
          </span>{" "}
        </button>
      </div>
      <div className="floating-actions astro-dcpclmto"></div>
    </div>
    {/* Banner Content*/}
    <Banner data = {banner}/>
    {/* Main Content */}
    <MainContent content ={banner} />
    {/* Recomended */}
    <Recomended banner ={banner}/>
  </div>
</div>
</>
    )
}
export default ContentContainer;